import { FC, ReactElement } from 'react'
import NavBar, { NavBarProps } from '../../components/navBar'
import { RoutesEnum } from '../../utils/routesEnum'

const Navigation: FC<NavBarProps> = ({ variant }): ReactElement | null => {
  return (
    <NavBar
      variant={variant}
      navigation={[
        { name: 'Como funciona?', href: '/#how-it-works' },
        { name: 'Depoimentos', href: '/#testimony' },
        { name: 'FAQ', href: '/#faq' },
        { name: 'Preços', href: '/#plans' },
        { separate: true },
        { name: 'Login', to: RoutesEnum.LOGIN },
        { name: 'Teste Grátis!', to: RoutesEnum.REGISTER, type: 'button' }
      ]}
    />
  )
}

export default Navigation
